export enum SupportedLanguages {
    English = 'en',
    Bulgarian = 'bg',
}
